import React, { Component } from "react";
import { MdClose } from "react-icons/md";
import InfiniteScroll from "react-infinite-scroll-component";
import Empty from "../../base/features/blocks/Empty";
import SimpleHeader from "../../base/features/blocks/SimpleHeader";
import Spinner from "../../base/features/micro/Spinner";
import { apiService } from "../../base/utils/service";
import { isSiteDomain } from "../../settings/domainManager";
import UserCustomProductBlock from "./blocks/UserCustomProductBlock";

class UserCustomProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      products: null,
      searchKey: "",
      hasMore: false,
      next: "",
    };
  }
  componentDidMount() {
    this.getProducts();
  }
  getProducts() {
    let q = this.state.searchKey;
    apiService(
      `v1/personalized-product-requests?q=${q}${
        isSiteDomain ? "&shop=domain" : ""
      }`,
      "get"
    ).then((data) => {
      if (data) {
        if (q === this.state.searchKey) {
          this.setState({
            products: data.results,
            hasMore: data.next ? true : false,
            next: data.next,
          });
        }
      }
    });
  }
  fetchMore() {
    apiService(this.state.next, "get").then((data) => {
      if (data) {
        var newProducts = this.state.products;
        newProducts = newProducts.concat(data.results);

        this.setState({
          products: newProducts,
          next: data.next,
          hasMore: data.next ? true : false,
        });
      }
    });
  }
  render() {
    return (
      <div className="container-fluid">
        <SimpleHeader text="محصول های سفارشی" />
        <body className="" style={{ marginTop: "80px", marginBottom: "20px" }}>
          {this.state.products ? (
            <section>
              <div className="row mx-0">
                <div className="col-12 px-0 py-3 text-center position-relative">
                  <input
                    type="text"
                    value={this.state.searchKey}
                    onChange={(e) =>
                      this.setState({ searchKey: e.target.value }, () => {
                        this.getProducts();
                      })
                    }
                    className="form-control px-3 py-2 rounded14 w-100"
                    style={{ height: "44px" }}
                    placeholder="جستجو کنید"
                  />
                  {this.state.searchKey.length !== 0 && (
                    <MdClose
                      size={26}
                      style={{ left: "12px", top: "0", bottom: "0" }}
                      className="position-absolute my-auto"
                      onClick={() =>
                        this.setState({ searchKey: "" }, () => {
                          this.getProducts();
                        })
                      }
                    />
                  )}
                </div>
              </div>
              <InfiniteScroll
                dataLength={this.state.products.length}
                next={() => this.fetchMore()}
                hasMore={this.state.hasMore}
                className="row mx-0"
                loader={<Spinner />}
              >
                {this.state.products.length === 0 && (
                  <Empty type="product" text="محصول سفارشی ثبت نشده است" />
                )}
                {this.state.products.map((product, p) => (
                  <UserCustomProductBlock product={product} />
                ))}
              </InfiniteScroll>
            </section>
          ) : (
            <Spinner />
          )}
        </body>
      </div>
    );
  }
}

export default UserCustomProducts;
